import ProceduresTableActions from '@/components/customer-dashboard/ProceduresTableActions.vue';
import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import type { Procedure } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<Procedure>[] = [
    // {
    //     accessorKey: 'procedure_deadline',
    //     header: ({ column }) =>
    //         h(DataTableColumnHeader, {
    //             column: column,
    //             title: 'procedures.table.deadline',
    //         }),
    // },
    {
        accessorKey: 'procedure_deadline_text',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'procedures.table.deadline_text',
            }),
    },
    {
        accessorKey: 'procedure_task',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'procedures.table.task',
            }),
    },
    {
        accessorKey: 'procedure_responsible',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'procedures.table.responsible',
            }),
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(ProceduresTableActions, {
                procedure: row.original,
            });
        },
    },
];
